@switch (state()) {
  @case ('EMPTY') {
    <div class="size-5 inline-flex items-center justify-center">
      <span
        class="size-2 rounded-full bg-on-surface-disabled dark:bg-on-surface-disabled-darkmode"
      ></span>
    </div>
  }
  @case ('IN_PROGRESS') {
    <div class="size-5 inline-flex items-center justify-center">
      <div
        class="size-4 inline-flex items-center justify-center rounded-full bg-primary-soft dark:bg-primary-soft-darkmode"
      >
        <span class="size-2 rounded-full bg-primary dark:bg-primary-darkmode"></span>
      </div>
    </div>
  }
  @case ('COMPLETE') {
    <span class="text-success dark:text-success-darkmode">
      <ng-icon name="heroCheckCircleSolid" size="20" class="!block" />
    </span>
  }
}
